import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/useLanguage";
import { useEffect } from "react";

const ResetPassword = () => {
  const { t } = useLanguage();
  const location = useLocation();
  
  useEffect(() => {
    if (import.meta.env.DEV) {
      console.log("ResetPassword page is rendering");
      console.log("Current pathname:", location.pathname);
      console.log("Current search:", location.search);
      console.log("Current hash:", location.hash);
      console.log("Full URL:", window.location.href);
    }
  }, [location]);

  return (
    <div>
      <ResetPasswordForm />
    </div>
  );
};

export default ResetPassword;